import React, { useState } from 'react'
import Nav from './Nav'
import { IFooter } from './types'
import Slider from 'react-slick'
import Link from 'components/Link'
import { StaticImage } from 'gatsby-plugin-image'

const defaultSliders = [
    {
        label: 'Property management',
        url: '/property-management',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/product2.jpg"
            />
        ),
    },
    {
        label: 'Real estate crm',
        url: '/real-estate-crm',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/product3.jpg"
            />
        ),
    },
    {
        label: 'Real estate marketing',
        url: '/real-estate-marketing',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/product4.jpg"
            />
        ),
    },
    {
        label: 'Mobile apps',
        url: '/real-estate-mobile-apps',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/product5.jpg"
            />
        ),
    },
    {
        label: 'Transaction-management',
        url: '/transaction-management',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/product6.jpg"
            />
        ),
    },
]

const defaultSliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToScroll: 11,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 0,
    speed: 100000,
    cssEase: 'linear',
}

const Slide = ({ image, label }: { image: React.ReactNode; label: string }) => {
    return (
        <div className="group relative">
            <div className="relative transition-transform hover:scale-[1.1] active:scale-[1.09]">{image}</div>
            <div className="invisible absolute left-0 bottom-4 right-0 flex justify-center group-hover:visible">
                <span className=" rounded-md bg-tan/75 px-3 text-lg shadow-xl backdrop-blur">{label}</span>
            </div>
        </div>
    )
}

export default function ProductSlider({ title, productSliderSettings, productSlides }: IFooter) {
    const [activeSlide, setActiveSlide] = useState(0)
    const sliderSettings = productSliderSettings || defaultSliderSettings
    const slides = productSlides || defaultSliders
    return (
        <section className="my-14 text-center">
            <div className="-mx-5 -mb-20 pt-28">
                <Slider
                    beforeChange={(_oldIndex, newIndex) => setActiveSlide(newIndex)}
                    className="product-readys-slider"
                    {...sliderSettings}
                >
                    {slides.map((slide, index) => {
                        return (
                            <Link key={index} className="cursor-pointer" to={slide.url}>
                                <Slide {...slide} />
                            </Link>
                        )
                    })}
                </Slider>
            </div>
        </section>
    )
}
